import { renderDraftJsTemplate, renderTemplate, renderTemplateText, } from "./renderer.js";
// Scope descriptors are used by picker UIs (via `availablePlaceholders`) to
// filter the registry. They are NOT used by the renderer — at render time
// Handlebars walks the supplied context object directly, and the wrappers'
// strict TypeScript context types are the runtime contract.
const SCOPE = {
    quote: {
        channel: "document",
        entitiesInScope: [
            "document",
            "contractee",
            "endClient",
            "contractor",
            "project",
            "calculation",
            "rootItem",
            "mainProduct",
        ],
    },
    invoice: {
        channel: "document",
        entitiesInScope: ["invoice", "client", "organisation", "user"],
    },
    // PO / TR / ML expose no doc-header placeholders — only actor + org + user.
    purchaseOrder: {
        channel: "document",
        entitiesInScope: ["supplier", "organisation", "user"],
    },
    timeReport: {
        channel: "document",
        entitiesInScope: ["client", "organisation", "user"],
    },
    materialList: {
        channel: "document",
        entitiesInScope: ["organisation", "user"],
    },
    projectEmail: {
        channel: "email",
        entitiesInScope: ["recipient", "organisation", "user", "project"],
    },
    requirementEmail: {
        channel: "email",
        entitiesInScope: [
            "recipient",
            "organisation",
            "user",
            "requirement",
            "project",
        ],
    },
    quoteEmail: {
        channel: "email",
        entitiesInScope: [
            "recipient",
            "organisation",
            "user",
            "document",
            "project",
        ],
    },
    crmEmail: {
        channel: "email",
        entitiesInScope: ["recipient", "organisation", "user"],
    },
    memberEmail: {
        channel: "email",
        entitiesInScope: ["member", "organisation", "user"],
    },
};
export function renderQuoteTemplate(body, ctx) {
    return renderTemplate(body, ctx);
}
export function renderInvoiceTemplate(bodyJson, fallbackPlainText, ctx) {
    return renderDraftJsTemplate(bodyJson, fallbackPlainText, ctx);
}
export function renderPurchaseOrderTemplate(bodyJson, fallbackPlainText, ctx) {
    return renderDraftJsTemplate(bodyJson, fallbackPlainText, ctx);
}
export function renderTimeReportTemplate(bodyJson, fallbackPlainText, ctx) {
    return renderDraftJsTemplate(bodyJson, fallbackPlainText, ctx);
}
export function renderMaterialListTemplate(bodyJson, fallbackPlainText, ctx) {
    return renderDraftJsTemplate(bodyJson, fallbackPlainText, ctx);
}
export function renderProjectEmailTemplate(body, ctx) {
    return renderTemplate(body, ctx);
}
export function renderRequirementEmailTemplate(body, ctx) {
    return renderTemplate(body, ctx);
}
export function renderQuoteEmailTemplate(body, ctx) {
    return renderTemplate(body, ctx);
}
export function renderCrmEmailTemplate(body, ctx) {
    return renderTemplate(body, ctx);
}
export function renderMemberEmailTemplate(body, ctx) {
    return renderTemplate(body, ctx);
}
export function renderMemberEmailSubject(subject, ctx) {
    return renderTemplateText(subject, ctx);
}
// ─── Re-exported scope descriptors ────────────────────────────────────────────
export const QUOTE_SCOPE = SCOPE.quote;
export const INVOICE_SCOPE = SCOPE.invoice;
export const PURCHASE_ORDER_SCOPE = SCOPE.purchaseOrder;
export const TIME_REPORT_SCOPE = SCOPE.timeReport;
export const MATERIAL_LIST_SCOPE = SCOPE.materialList;
export const PROJECT_EMAIL_SCOPE = SCOPE.projectEmail;
export const REQUIREMENT_EMAIL_SCOPE = SCOPE.requirementEmail;
export const QUOTE_EMAIL_SCOPE = SCOPE.quoteEmail;
export const CRM_EMAIL_SCOPE = SCOPE.crmEmail;
export const MEMBER_EMAIL_SCOPE = SCOPE.memberEmail;
// The single derivation shared by the available-placeholders picker, the
// editor-side validation and the save-time rejection. If they could disagree, a
// token the picker offers would eventually be one the validator rejects.
export function emailTemplateScope(context) {
    return context ? EMAIL_SCOPE_BY_CONTEXT[context] : CRM_EMAIL_SCOPE;
}
const EMAIL_SCOPE_BY_CONTEXT = {
    CRM: CRM_EMAIL_SCOPE,
    PROJECT: PROJECT_EMAIL_SCOPE,
    QUOTE: QUOTE_EMAIL_SCOPE,
    REQUIREMENT: REQUIREMENT_EMAIL_SCOPE,
    MEMBER: MEMBER_EMAIL_SCOPE,
};
//# sourceMappingURL=scopedRenderers.js.map